import { Gift, Ruler, Scissors, Sparkles } from "lucide-react";

export const NAV = [
  { label: "Collection", to: "/collection" },
  { label: "Personalization", to: "/personalization" },
  { label: "About Ella", to: "/about" },
  { label: "Contact", to: "/contact" },
] as const;

export const FOOTER_LINKS = [{ label: "Home", to: "/" }, ...NAV] as const;

export const REVIEWS = [
  {
    quote:
      "Ella makes beautiful doll clothes! The quality is excellent and she offers a great selection. She will also accept custom orders. I highly recommend contacting Ella if you are looking for doll clothes! Quality items at great priced!!!",
    name: "Shari Tiede",
  },
  {
    quote: "Really awesome my little girl lover her stuff thank you Ella.",
    name: "Nick Burns",
  },
] as const;

export const HIGHLIGHT_BADGES = [
  { icon: Scissors, label: "Handmade Quality" },
  { icon: Ruler, label: "18-inch Doll Sizing" },
  { icon: Sparkles, label: "Personalized Options" },
  { icon: Gift, label: "Gift-Ready" },
] as const;

export const FEATURES = [
  {
    title: "Truly Handmade",
    copy: "Knit, crocheted, and sewn by hand — never factory-made or mass-produced.",
  },
  {
    title: "Lasting Keepsakes",
    copy: "Boutique-quality outfits made to be treasured, built to last well past the wrapping paper.",
  },
  {
    title: "Proven Craftsmanship",
    copy: "Years of hands-on sewing, knitting, and crochet experience in every seam.",
  },
  {
    title: "Friendly, Personal Service",
    copy: "Ella works with you one-on-one to find or create the perfect outfit.",
  },
] as const;

export const CONTACT_STEPS = [
  {
    title: "Reach Out",
    copy: "Call, email, or send the form and tell Ella what you're looking for.",
  },
  {
    title: "Find the Perfect Fit",
    copy: "Ella follows up, learns what your doll lover likes, and shares options and ideas.",
  },
  {
    title: "Gift & Delight",
    copy: "Receive a handmade outfit that's ready to wrap and impossible not to love.",
  },
] as const;

export const CUSTOM_STEPS = [
  {
    title: "Share Your Idea",
    copy: "Tell Ella the colors, style, theme, or occasion you have in mind — even a rough sketch of the look is plenty to start.",
  },
  {
    title: "Shape It Together",
    copy: "She follows up personally, asks a few questions, and shares ideas so the piece feels right before a single stitch is made.",
  },
  {
    title: "Made Just for Them",
    copy: "Ella knits, crochets, or sews the outfit by hand. You receive a one-of-a-kind gift, ready to wrap.",
  },
] as const;

export const CUSTOMIZABLE = [
  {
    title: "Colors",
    copy: "Favorite shades, soft pastels, holiday brights, or a palette to match a bedroom, party, or family photo.",
  },
  {
    title: "Styles",
    copy: "Dresses, sets, headbands, booties, and special-occasion looks — knit, crocheted, or sewn to suit how they play.",
  },
  {
    title: "Themes",
    copy: "Birthdays, seasons, storybook favorites, and little details that make the outfit feel like theirs alone.",
  },
  {
    title: "Occasions",
    copy: "Everyday play, holidays, weddings, portraits, or a keepsake gift for a grandchild — Ella will help you choose.",
  },
] as const;

export const WHAT_ELLA_MAKES = [
  {
    title: "Dresses",
    copy: "Everyday dresses in cheerful colors, from simple ripple-stitch styles to trimmed yokes with matching headbands.",
  },
  {
    title: "Gowns",
    copy: "Special-occasion gowns, including bridal looks with veils and flower crowns for pretend weddings and keepsake photos.",
  },
  {
    title: "Sets",
    copy: "Coordinated sets that arrive complete — gown or dress with bonnet, slip, headband, and booties finished to match.",
  },
  {
    title: "Accessories",
    copy: "Headbands, bonnets, booties, and finishing details that can be made to match an outfit your doll lover already owns.",
  },
] as const;

export const PERFECT_FOR = [
  "Birthdays",
  "Christmas",
  "Easter outfits",
  "Weddings & flower-girl looks",
  "Grandparent gifts",
  "Just because",
] as const;

export const CUSTOM_IDEAS = [
  {
    title: "A favorite color",
    copy: "A dress worked up in the one shade a child asks for every single time — purple, coral, buttercup yellow, or something softer.",
  },
  {
    title: "A matching moment",
    copy: "A doll outfit that echoes a child's own dress for a birthday, a holiday photo, or a family wedding.",
  },
  {
    title: "A holiday look",
    copy: "Christmas reds and creams, Easter pastels, or a seasonal set that comes out of the box year after year.",
  },
  {
    title: "A keepsake occasion",
    copy: "A bridal gown, christening-style gown, or a set made to mark a new grandchild — finished to be kept, not worn out.",
  },
] as const;

export const CUSTOM_FAQ = [
  {
    q: "Can I request specific colors?",
    a: "Yes. Colors are one of the easiest things to personalize — tell Ella the shade or palette you have in mind and she will let you know what she can work with.",
  },
  {
    q: "Can an outfit match a theme or another outfit?",
    a: "Often, yes. Share a photo, a description, or the occasion, and Ella will talk through what's possible before anything is made.",
  },
  {
    q: "How do I start a custom order?",
    a: "Send a note through the contact form, call 989-388-3556, or email wisella@aol.com with your idea. Ella follows up personally.",
  },
  {
    q: "How much does a custom piece cost?",
    a: "Pricing depends on the piece. Ella keeps her work affordable and will confirm pricing with you directly once she knows what you'd like.",
  },
  {
    q: "How long does a custom order take?",
    a: "It depends on the piece and what she has underway. Ella will confirm timing when you reach out — tell her if you have a date in mind.",
  },
  {
    q: "Will it fit my doll?",
    a: "Pieces are made to fit 18-inch American-style dolls. If your doll is a different size, mention it and Ella will let you know what she can do.",
  },
] as const;

export const GENERAL_FAQ = [
  {
    q: "Do the outfits fit 18-inch dolls?",
    a: "Yes — every piece is made to fit 18-inch American-style dolls. Doll Clothes by Ella Wise is an independent maker and isn't affiliated with any doll brand.",
  },
  {
    q: "Do you take custom orders?",
    a: "Yes. Personalized, made-to-order pieces are a big part of what Ella does. You can read how it works on the personalization page.",
  },
  {
    q: "How do I find out a price?",
    a: "Just ask. Ella keeps her prices affordable and will confirm pricing for the piece you're interested in when you get in touch.",
  },
  {
    q: "Can you help me choose a gift?",
    a: "Absolutely. Tell Ella a little about the child — their favorite colors, the occasion, how they play — and she'll suggest options.",
  },
  {
    q: "Do you make matching accessories?",
    a: "Yes. Headbands, bonnets, and booties are often made to match a dress or gown. Ask about accessories for a piece you like.",
  },
  {
    q: "How do I place an order?",
    a: "There's no shopping cart. Send the form, call, or email, and Ella will confirm availability, options, and pricing with you personally.",
  },
  {
    q: "How should I care for a handmade piece?",
    a: "Knit and crochet items do best hand washed in cool water and laid flat to dry. Ask Ella if you have a question about a specific piece.",
  },
  {
    q: "Where is Ella based?",
    a: "Midland, Michigan. Every piece is knit, crocheted, or sewn by Ella herself.",
  },
] as const;

export const HER_CRAFT = [
  {
    title: "Knitting",
    copy: "Knit stitches give an outfit softness and a gentle stretch, so a piece slips on easily and keeps its shape through plenty of play.",
  },
  {
    title: "Crochet",
    copy: "Crochet brings the texture and detail Ella is known for — scalloped edges, ripple stitches, rosettes, and trims worked row by row.",
  },
  {
    title: "Sewing",
    copy: "Sewing adds structure: lined bodices, satin bows, lace appliqué, and veils that hold their shape for photographs and keepsakes.",
  },
] as const;

export const ELLA_DIFFERENCE = [
  {
    title: "One maker, start to finish",
    copy: "Ella designs, stitches, and finishes every piece herself. Nothing is outsourced and nothing is mass-produced.",
  },
  {
    title: "Made-to-order attention",
    copy: "Because pieces are made one at a time, there's room to change a color, add an accessory, or shape a piece around an occasion.",
  },
  {
    title: "Gift-ready quality",
    copy: "Outfits are finished so they look boutique-bought when they're opened, and are built to survive real play afterwards.",
  },
] as const;

export const CARE_TIPS = [
  {
    title: "Hand wash, cool water",
    copy: "A gentle hand wash in cool water with mild soap is kindest to knit and crochet stitches. Avoid wringing or twisting.",
  },
  {
    title: "Lay flat to dry",
    copy: "Press out excess water in a towel, then reshape the piece and lay it flat to dry rather than hanging it.",
  },
  {
    title: "Store folded and dry",
    copy: "Fold pieces loosely and keep them somewhere dry. Ribbons and veils keep their shape best when they aren't crushed.",
  },
  {
    title: "Ask if you're unsure",
    copy: "This is general guidance for handmade knit and crochet. If you have a question about a specific piece, just ask Ella.",
  },
] as const;

export const ORDER_STEPS = [
  {
    title: "Browse the collection",
    copy: "Look through the pieces here and note anything that catches your eye — or a style you'd like something similar to.",
  },
  {
    title: "Reach out about a piece",
    copy: "Use the ask link on any item, call, or email. Tell Ella which piece and who it's for.",
  },
  {
    title: "Ella confirms the details",
    copy: "She'll confirm availability, pricing, and any options — colors, accessories, or a made-to-order version.",
  },
  {
    title: "Made and ready for gifting",
    copy: "Your piece is prepared or handcrafted, finished by hand, and ready to wrap.",
  },
] as const;

export const INTEREST_OPTIONS = [
  '18" American Doll Clothes',
  "Custom / Personalized Order",
  "Gift Help",
  "Other",
] as const;

export const DEFAULT_INTEREST = INTEREST_OPTIONS[0];
export const CUSTOM_INTEREST = INTEREST_OPTIONS[1];

